// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>4</span>&nbsp;&nbsp;Seek the Lord and his strength;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;seek his face continually.<br> </p> </div></div>";
// Exports
module.exports = code;